// Prepara l'immagine scelta dal rullino: le foto da smartphone sono da 12+ MP e
// su iOS possono far crashare la webview (schermo nero). Le riduciamo a misura
// storia mantenendo qualita' e orientamento.
const MAX_W = 1440;
const MAX_H = 2560;

export const prepareImage = (file, maxW = MAX_W, maxH = MAX_H) =>
  new Promise((resolve) => {
    if (!file?.type?.startsWith("image/")) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const ratio = Math.min(1, maxW / img.width, maxH / img.height);
        if (ratio >= 1 && file.size < 1.5 * 1024 * 1024) {
          URL.revokeObjectURL(url);
          return resolve(file);
        }
        const w = Math.max(1, Math.round(img.width * ratio));
        const h = Math.max(1, Math.round(img.height * ratio));
        const cv = document.createElement("canvas");
        cv.width = w;
        cv.height = h;
        cv.getContext("2d").drawImage(img, 0, 0, w, h);
        cv.toBlob(
          (blob) => {
            URL.revokeObjectURL(url);
            resolve(blob ? new File([blob], "story.jpg", { type: "image/jpeg" }) : file);
          },
          "image/jpeg",
          0.9
        );
      } catch {
        URL.revokeObjectURL(url);
        resolve(file);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null); // formato non leggibile dal browser
    };
    img.src = url;
  });
